import { getLocations } from './utils/commonApi';

const store = {
  debug: false,
  state: {
    facility: null,
    facilities: [],
    facilityData: {},
  },
  getDashboardPath() {
    return this.state.facility ? 'Facility Dashboard' : 'Dashboard';
  },
  getHeader() {
    return `${String(this.$root.state.facilityData.code).toUpperCase()}`;
  },
  setFacilityAction(facility) {
    if (this.debug) console.log('setFacilityAction triggered with ', facility);

    this.state.facility = facility;
  },
  setFacilityDataAction(facilityData) {
    if (this.debug) console.log('setFacilityDataAction triggered with', facilityData);
    this.state.facilityData = facilityData;
  },
  resetFacilityDataAction() {
    this.state.facilityData = { title: '', showTip: true };
  },
  resetFacilityAction() {
    if (this.debug) console.log('resetFacilityAction triggered');

    this.state.facility = null;
  },
  async fetchFacilities() {
    const facilities = await getLocations(this.$keycloak.token);

    if (this.debug) console.log('setFacilities triggered');

    this.state.facilities = facilities;
  },
  setFacilities(facilities) {
    if (this.debug) console.log('setFacilities triggered');

    this.state.facilities = facilities;
  },
};

export default store;



// WEBPACK FOOTER //
// ./src/store.js